
export default function ajax(options) {
  let defaults = {
    type: 'post',
    async: true,
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    cache: false,
    beforeSend: function (xhr) {
      xhr.setRequestHeader("Content-type", "application/json; charset=utf-8");
    }
  }
  window.$.extend(options,defaults)
  return window.$.ajax(options)
}